export const fakesPreviousResultsUrlQuery = 'previous';
